'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CreateAccountForm } from '@/components/auth/CreateAccountForm';
import { env } from '@/constant/configs';

interface RegisterFormProps {
  userAuthToken?: string;
}

const RegisterForm = ({ userAuthToken }: RegisterFormProps) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={env.re_captcha_key}>
      <CreateAccountForm userAuthToken={userAuthToken} />
    </GoogleReCaptchaProvider>
  );
};

export default RegisterForm;
